var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emap-flow-modal-addAssignee" },
    [
      _c(
        "Modal",
        {
          attrs: { title: _vm.$LocalH5("toolbar.addHandler") },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c(
            "Form",
            { ref: "form", attrs: { model: _vm.form, "label-width": 80 } },
            [
              _c(
                "FormItem",
                {
                  attrs: {
                    label: _vm.$LocalH5("toolbar.node"),
                    prop: "taskId",
                  },
                },
                [
                  _c(
                    "Select",
                    {
                      attrs: {
                        transfer: "",
                        disabled: _vm.nodeList.length === 1,
                      },
                      on: { "on-change": _vm.nodeChange },
                      model: {
                        value: _vm.form.taskId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "taskId", $$v)
                        },
                        expression: "form.taskId",
                      },
                    },
                    _vm._l(_vm.nodeList, function (item, index) {
                      return _c(
                        "Option",
                        { key: index, attrs: { value: item.taskId } },
                        [_vm._v(_vm._s(item.nodeName))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                {
                  attrs: {
                    label: _vm.$LocalH5("toolbar.handler"),
                    prop: "assignees",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "add-assignee-item",
                      class: { "add-assignee-disabled": !_vm.form.taskId },
                      on: {
                        click: function ($event) {
                          _vm.customPick = !!_vm.form.taskId
                        },
                      },
                    },
                    [
                      _vm._t("default", function () {
                        return [
                          _vm._l(
                            _vm.defaultAssigneesObj,
                            function (item, index) {
                              return _c(
                                "Tag",
                                { key: index, attrs: { name: item.userId } },
                                [_vm._v(_vm._s(item.userName))]
                              )
                            }
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.assigneesObj, function (item, index) {
                            return _c(
                              "Tag",
                              {
                                key: index,
                                attrs: {
                                  type: "border",
                                  color: "blue",
                                  name: item.userId,
                                },
                              },
                              [_vm._v(_vm._s(item.userName))]
                            )
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.hasMultiInstance
                ? _c(
                    "FormItem",
                    {
                      attrs: {
                        label: _vm.$LocalH5("toolbar.handlerGroup"),
                        prop: "instAssignees",
                      },
                    },
                    [
                      _c(
                        "Select",
                        {
                          attrs: {
                            transfer: "",
                            multiple: "",
                            noDelDefault: "",
                          },
                          model: {
                            value: _vm.form.instAssignees,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "instAssignees", $$v)
                            },
                            expression: "form.instAssignees",
                          },
                        },
                        _vm._l(_vm.groups, function (item, index) {
                          return _c(
                            "Option",
                            {
                              key: index,
                              attrs: {
                                value: item.id,
                                disabled: item.disabled,
                              },
                            },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { size: "large" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$LocalH5("buttonCancel")))]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: { type: "primary", size: "large" },
                  on: { click: _vm.onConfirm },
                },
                [_vm._v(_vm._s(_vm.$LocalH5("buttonConfirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("emap-flow-pick", {
        attrs: {
          multiple: "",
          disabledOptions: _vm.form.defaultAssignees,
          options: _vm.form.assignees,
        },
        on: { "on-confirm": _vm.emapflowPick },
        model: {
          value: _vm.customPick,
          callback: function ($$v) {
            _vm.customPick = $$v
          },
          expression: "customPick",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }